import { defineComponent, renderSlot } from 'vue'
import { buildProps, definePropType } from '@vuesax-plus/utils'
import { provideGlobalConfig } from '@vuesax-plus/hooks'

import type { ExtractPropTypes } from 'vue'
import type { Language } from '@vuesax-plus/locale'
import type { ColorProviderContext } from '@vuesax-plus/constants'

export const configProviderProps = buildProps({
  /**
   * @description global Initial zIndex
   */
  zIndex: Number,
  /**
   * @description global component className prefix (cooperated with [$namespace](https://github.com/vuesax-x/vuesax-plus/blob/main/packages/theme-chalk/src/mixins/config.scss#L1)) | ^[string]
   */
  namespace: {
    type: String,
    default: 'vs',
  },
  color: {
    type: definePropType<ColorProviderContext>(Object),
  },
  /**
   * @description Locale Object
   */
  locale: {
    type: definePropType<Language>(Object),
  },
} as const)

export type ConfigProviderProps = ExtractPropTypes<typeof configProviderProps>

const ConfigProvider = defineComponent({
  name: 'VsConfigProvider',
  props: configProviderProps,

  setup(props, { slots }) {
    const config = provideGlobalConfig(props)

    return () => renderSlot(slots, 'default', { config: config?.value })
  },
})

export type ConfigProviderInstance = InstanceType<typeof ConfigProvider>

export default ConfigProvider
